import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { List } from 'components/shared/List/List'
import { Separator } from 'components/shared/Separator/Separator'

import styles from './Questions.module.scss'

export const Questions = ({ activeIndex, questions, setActiveIndex }) => (
  <Box className={styles.questions}>
    <List ariaLabel="questions" direction="column">
      {R.addIndex(R.map)(({ description, title }, index) => {
        const count = index + 1
        const length = R.length(questions)

        return (
          <React.Fragment key={title}>
            {R.gt(index, 0) ? (
              <Separator maxWidth="92.5%" tagName="span" />
            ) : null}
            <List.Item
              className={cx(styles.card, {
                [styles.active]: R.equals(index, activeIndex),
              })}
            >
              <button
                className={styles.button}
                onClick={() => setActiveIndex(index)}
              >
                <Box direction="column" tagName="span">
                  <span className={styles.count}>
                    {t`${count} of ${length}`}
                  </span>
                  <span className={styles.question}>{title}</span>
                </Box>
              </button>
              {R.gt(R.length(description), 0) &&
              R.equals(index, activeIndex) ? (
                <Box className={styles.container} direction="column">
                  <p className={styles.description}>{description}</p>
                </Box>
              ) : null}
            </List.Item>
          </React.Fragment>
        )
      }, questions)}
    </List>
  </Box>
)
